export default function Container({ children }) {
  return (
    <div className="mx-auto max-w-screen-2xl py-8 px-4 overflow-x-auto">
      {children}
    </div>
  );
}
